
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorDeCurso } from '../../controlador-crear-curso';
    import preguntas from './cursos-crear-preguntas.vue';
    import recursos from './cursos-crear-recursos.vue';
    import { Curso } from '@/__env/lib/Cursos';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            preguntas,
            recursos,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador(): ControladorDeCurso { return Model; }
        public Curso: Curso = new Curso();

        public Estado: string = 'cargando';


        protected Eventos: Function[] = [];
        beforeDestroy() { this.Eventos.forEach( x => x() ); }
        async mounted()
        {
            this.Estado = this.Controlador.Vista.Estado;
            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( () => this.Estado = this.Controlador.Vista.Estado ) );
            this.Eventos.push( this.Controlador.onGuardar.subscribe( () => this.Controlador.Curso = this.Curso ) );

            console.log( this.$route.query );
            if ( parseInt( this.$route.query.id ) > 0 )
                await this.Controlador.Iniciar( Number( this.$route.query.id ) );
            else
                await this.Controlador.Iniciar( new Curso() );
            this.Curso = this.Controlador.Curso;
        }

        public async Guardar()
        {
            await this.Controlador.Guardar();
        }

        public async Cancelar()
        {
            this.Controlador.Cancelar();
        }

    }
